module.exports = __webpack_public_path__ + "static/media/web-portal-badge@3x.1493dce8.png";